import React from "react"
import "../index.less"

import emptyEvolution from "images/empty-evolution-dashboard.svg"
import { loadTexts } from "../../../utils/i18n"

const EvolutionEmptyState = (props) => {
  const intl = loadTexts("reports_dashboard")
  return (
    <>
      <img
        src={emptyEvolution}
        alt="empty evolution"
        className="report-card-body-empty-evolution"
      />
      <div className="report-card-body-description">
        {intl.dashboard.reportCard.evolutionEmptyState}
      </div>
    </>
  )
}

export default EvolutionEmptyState
